import React, { Fragment, useState, Suspense, lazy, useEffect } from 'react';
import { Helmet } from "react-helmet";
import Footer from '../../components/footer';
import Hero from '../../components/hero';
import Navbar from '../../components/Navbar';
import Scrollbar from '../../components/scrollbar';
// import Logo from '../../images/Logo/logo-big.png';
import Logo from '../../images/Logo/logo-white-bg.png';
import CustomLoader from '../../components/CustomLoader';

const AboutUs           = lazy(() => import('./aboutUs'));
const AnniversaryBanner = lazy(() => import('./AnniversaryBanner'));
const Performance       = lazy(() => import('../Performance'));
const WhyChooseUs       = lazy(() => import('./WhyChooseUs'));
const MissionVisionSection = lazy(() => import('./mission'));
const Services          = lazy(() => import('../Service'));
const IndustryCarousel  = lazy(() => import('../Industry/IndustryCarousel'));

const HomePage = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scroll(0, 0);
        const t = setTimeout(() => setLoading(false), 200);
        return () => clearTimeout(t);
    }, []);

    return (
        <Fragment>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Deep Prabha Transchem — India's Trusted Chemical Supplier</title>
                <link rel="canonical" href="https://www.deepprabha.com/" />
                <meta name="description" content="Deep Prabha Transchem — Leading importers, exporters & suppliers of Solvents, Petrochemicals & Pharmaceutical Products in India. 10+ years of excellence, serving 85+ countries. Get bulk chemical supply at best prices." />
                <meta name="keywords" content="chemical supplier india, solvent supplier mumbai, petrochemical distributor india, pharmaceutical chemicals supplier, industrial chemicals india, deep prabha transchem, chemical importer exporter india, bulk chemicals india, acetone ethanol IPA toluene supplier" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.deepprabha.com/" />
                <meta property="og:site_name" content="Deep Prabha Transchem" />
                <meta property="og:title" content="Deep Prabha Transchem — India's Trusted Chemical Supplier" />
                <meta property="og:description" content="Celebrating 10 years of excellence in chemical supply across 85+ countries." />
                <meta property="og:image" content="https://www.deepprabha.com/logo512.png" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Deep Prabha Transchem" />
                <meta name="twitter:description" content="India's leading chemical supplier since 2015." />
                <meta name="twitter:image" content="https://www.deepprabha.com/logo512.png" />
            </Helmet>

            <CustomLoader show={loading} />
            <Navbar topbarBlock={'wpo-header-style-3'} hclass={'wpo-header-style-3'} Logo={Logo} />

            {/* 1. Hero — full-screen with anniversary badge + stats */}
            <Hero />

            {/* 2. About Us */}
            <Suspense fallback={<div />}>
                <AboutUs />
            </Suspense>

            {/* 3. 10-Year Anniversary Banner */}
            <Suspense fallback={<div />}>
                <AnniversaryBanner />
            </Suspense>

            {/* 4. Global Trade Highlights (animated counters) */}
            <Suspense fallback={<div />}>
                <Performance />
            </Suspense>

            {/* 5. Why Choose Us */}
            <Suspense fallback={<div />}>
                <WhyChooseUs />
            </Suspense>

            {/* 6. Services */}
            <Suspense fallback={<div />}>
                <Services />
            </Suspense>

            {/* 7. Mission / Vision / Values */}
            <Suspense fallback={<div />}>
                <MissionVisionSection />
            </Suspense>

            {/* 8. Industries We Serve */}
            <Suspense fallback={<div />}>
                <IndustryCarousel />
            </Suspense>

            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default HomePage;